export default {
  namespaced  : true,
  state       : {
    podRoomType : 'public',
    
    podRoomId   : {
      public  : null,
      private : null
    },

    podRooms    : {
      public  : [],
      private : []
    },

    // podRoomsがもつプロパティ値です。listは例外的処理になるため含めません。
    podRoomMetaKeys : ['loaded', 'page', 'lastPage', 'total', 'currentPage'],
  },

  mutations   : {
    setPodRoomType(state, value){
      state.podRoomType = value;
    },

    setPodRoomId(state, payload){
      state.podRoomId[payload.podRoomType] = payload.podRoomId;
    },

    setPodRoomData(state, payload){
      for(let key of state.podRoomMetaKeys){
        if(typeof payload[key] === 'undefined'){
          payload[key] = null;
        }
      }

      if(typeof payload.list === 'undefined'){
        payload.list = [];
      }

      state.podRooms[state.podRoomType].push({
        id          : payload.podRoomId,
        list        : payload.list,
        loaded      : payload.loaded,

        page        : payload.page,
        lastPage    : payload.lastPage,
        total       : payload.total,
        currentPage : payload.currentPage
      });
    },

    changePodRoomData(state, payload){
      if(typeof state.podRooms[state.podRoomType][payload.podRoomIndex] === 'undefined') return;

      for(let key of state.podRoomMetaKeys){
        if(typeof payload[key] !== 'undefined'){
          state.podRooms[state.podRoomType][payload.podRoomIndex][key] = payload[key];
        }
      }
    },

    setPodRoomList(state, payload){
      if(payload.list.length === 0) return;

      for(let i = 0; i < state.podRooms[state.podRoomType].length; i++){
        if(payload.podRoomId === state.podRooms[state.podRoomType][i].id){
          switch(payload.behaviour){
            case 'prev':
              for(let message of payload.list){
                let couldRegist = true;

                for(let registerdMessage of state.podRooms[state.podRoomType][i].list){
                  if(registerdMessage.id === message.id){
                    couldRegist = false;
                  }
                }

                if(couldRegist){
                  state.podRooms[state.podRoomType][i].list.unshift(message);
                }
              }
            break;
            
            case 'refresh':
              payload.list = payload.list.reverse();

              if(state.podRooms[state.podRoomType][i].list.length === 0){
                state.podRooms[state.podRoomType][i].list = payload.list;
              }else{
                const newMessages = [];

                for(let message of payload.list){
                  let isNewMessage = true;

                  for(let existMessage of state.podRooms[state.podRoomType][i].list){
                    if(existMessage.id === message.id){
                      isNewMessage = false;

                      continue;
                    }
                  }

                  if(isNewMessage){
                    newMessages.push(message);
                  }
                }

                const firstMessageData = state.podRooms[state.podRoomType][i].list[0];

                for(let newMessage of newMessages){
                  if(parseInt(newMessage.id) < parseInt(firstMessageData.id)){
                    continue;
                  }

                  state.podRooms[state.podRoomType][i].list.push(newMessage);
                }
              }
            break;
          }
        }
      }
    },

    deletePodRoomMessage(state, value){
      for(let i = 0; i < state.podRooms[state.podRoomType].length; i++){
        if(state.podRoomId[state.podRoomType] === state.podRooms[state.podRoomType][i].id){
          const newList = [];

          for(let message of state.podRooms[state.podRoomType][i].list){
            if(value !== message.id){
              newList.push(message);
            }
          }

          state.podRooms[state.podRoomType][i].list = newList;
        }
      }
    },

    resetStore(state){
      state.podRoomType       = 'public';
      state.podRoomId.public  = null;
      state.podRoomId.private = null;
      state.podRooms.public   = [];
      state.podRooms.private  = [];
    }
  },

  actions : {
    updatePodRoomType(context, payload){
      context.commit('setPodRoomType', payload.value);
    },

    updatePodRoomId(context, payload){
      context.commit('setPodRoomId', payload);
    },

    updatePodRoomData(context, payload){
      // すでに登録されているかどうかを確認します。
      for(let i = 0; i < context.state.podRooms[context.state.podRoomType].length; i++){
        if(context.state.podRooms[context.state.podRoomType][i].id === payload.podRoomId){
          payload.podRoomIndex = i;

          context.commit('changePodRoomData', payload);

          // listデータが存在する場合は処理します。
          if(typeof payload.list !== 'undefined'){
            if(typeof payload.behaviour === 'undefined'){
              payload.behaviour = 'refresh';
            }

            context.commit('setPodRoomList', payload);
          }
          
          return;
        }
      }

      // 新規登録の場合の処理
      context.commit('setPodRoomData', payload);
    },

    deletePodRoomMessage(context, payload){
      context.commit('deletePodRoomMessage', payload.value);
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
}